// Utilities
import Vue from 'vue'
import i18n from '@/i18n'
import config from 'Services/config'
import userActions from 'ServicesActions/user'
import authentication from 'ServicesActions/authentication'
import { loadCurretUser, setUserCookie, clearUserCookie } from 'Services/helpers'

export const namespaced = true

export const state = {
  currentUser: null,
  diyUsers: null,
}

export const mutations = {
  SET_TOKEN(state, token) {
    authentication.set.token(token)
    // only for dev ⤵
    if (config.DEV) window.userToken = token
  },

  SET_DIY_USERS(state, users) {
    Vue.set(state, 'diyUsers', users)
  },

  SET_USER(state, user) {
    state.currentUser = user
    setUserCookie(user, user.remember)
  },

  SET_USER_UPDATE(state, userUpdate) {
    const updatedValue = Object.keys(userUpdate)[0]
    state.currentUser[updatedValue] = userUpdate[updatedValue]
    // Updating user cookie
    clearUserCookie(state.currentUser.remember)
    setUserCookie(state.currentUser, state.currentUser.remember)
  },

  FILL_USER(state, user) {
    state.currentUser = user
  },

  CLEAR_USER(state) {
    clearUserCookie(state.currentUser.remember)

    location.reload()
  },
}

export const actions = {
  async login({ commit, dispatch }, userInfo) {
    try {
      const response = await authentication.login(userInfo)
      const userToken = response.data.key
      commit('SET_TOKEN', userToken)
      // Obtenido el token, se realiza el login
      // Se establece el token del usuario actual
      let user = await userActions.get.user().self
      user.data.token = userToken
      user.data.language = response.data.language
      user.data.remember = userInfo.remember
      // setting user language
      i18n.locale = user.data.language

      commit('SET_USER', user.data)
      return user.data
    } catch (error) {
      if (error.response) {
        // Handling error notifications
        let message = ''
        if (error.response.status === 400) {
          message = 'Combinación de usuario/password incorrecta'
        } else if (error.response.status === 401) {
          message = 'No tienes permiso para realizar la petición'
        }
        const notification = {
          type: 'error',
          message,
          icon: true,
        }
        dispatch('notifications/add', notification, { root: true })
      }
      throw error
    }
  },

  async updateUserInfo(context, userInfo) {
    const currentUser = loadCurretUser()
    const updatedInfo = await userActions.patch.updateUserInfo(userInfo)
    let updatedValue = {}

    // If avatar has changed ( we're dealing with formData object) we reload the user cards.
    if (typeof userInfo.get === 'function') {
      updatedValue.avatar = updatedInfo.data.avatar
      if (currentUser.type === 'EMPLOYEE') context.dispatch('cards/getCards', null, { root: true })
      if (currentUser.type === 'CLIENT')
        context.dispatch('client/loadCards', currentUser.account.id, { root: true })
    } else {
      updatedValue.email_notifications = updatedInfo.data.email_notifications
    }

    context.commit('SET_USER_UPDATE', updatedValue)

    return updatedInfo
  },

  async resetUserPassword(context, newPasswordData) {
    const newPassword = await authentication.passwordReset(newPasswordData)
    return newPassword
  },

  async resetUserPasswordRequest(context, userEmail) {
    const newPassword = await userActions.post.passwordResetRequest(userEmail)
    return newPassword
  },

  async loadDIYUsers({ commit }) {
    try {
      const employees = await userActions.get.diy().employees
      commit('SET_DIY_USERS', employees.data)
      return employees
    } catch (error) {
      return error
    }
  },

  loadUser({ commit }, user) {
    commit('FILL_USER', user)
  },

  async logout({ commit }) {
    authentication.logout()
    commit('CLEAR_USER')
  },
}

export const getters = {
  loggedIn(state) {
    return state.currentUser && !!state.currentUser.token
  },

  getCurrentUser(state) {
    return state.currentUser || null
  },

  userType(state) {
    return state.currentUser && state.currentUser.type
  },

  isEditor(state) {
    return state.currentUser && state.currentUser.is_editor
  },

  isEmployee(state) {
    return state.currentUser && state.currentUser.type === 'EMPLOYEE'
  },

  shortName(state) {
    if (state.currentUser) {
      const firstNameLetter = state.currentUser.first_name.slice(0, 1)
      const firstLastNameLetter = state.currentUser.last_name.slice(0, 1)
      return firstNameLetter + firstLastNameLetter
    }
  },

  getEditors(state) {
    return state.diyUsers?.filter((user) => user.is_editor)
  },
}
